import {SeriesDto} from "../../models/interfaces/dtos/series.dto.interface.ts";
import {Series, SeriesInfo} from "../../models/interfaces/series.interface.ts";
import {
  SeriesCharacterInfoDto, SeriesInfoDto,
  SeriesTermInfoDto,
} from "../../models/interfaces/dtos/seriesInfo.dto.interface.ts";
import {isCharacterGender} from "../../models/types/charecterGender.ts";
import uuid4 from "uuid4";
import {SeriesGenresEnum} from "../../models/enums/seriesGenres.enum.ts";


export const transformSingleSeriesDtoToSingleSeries: (dto: SeriesDto) => Series = (dto: SeriesDto): Series => {
  return {
    id: dto.id,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    channelId: dto.channelId,
    name: dto.name,
    year: dto.year,
    createdBy: dto.createdBy,
    archived: dto.archived,
    info: transformSeriesInfoDtoToSeriesInfo(dto.info),
  }
};

export const transformSeriesInfoDtoToSeriesInfo = (infoDto: SeriesInfoDto): SeriesInfo => {
  return {
    sourceLanguage: infoDto.sourceLanguage,
    nameTranslations: {...infoDto.nameTranslations},
    characters: infoDto.characters.map((char: SeriesCharacterInfoDto) => ({
      characterId: uuid4(),
      originalLanguageName: char.originalLanguageName,
      name: char.name,
      otherNames: [...char.otherNames || []],
      ageRange: char.ageRange,
      gender: isCharacterGender(char.gender) ? char.gender : undefined,
    })),
    genres: infoDto.genres
      .map((genre: string) => {
        const match: SeriesGenresEnum | undefined = Object.values(SeriesGenresEnum).find((value: SeriesGenresEnum) => value.toLowerCase() === genre.toLowerCase());
        return match as SeriesGenresEnum;
      })
      .filter((g: SeriesGenresEnum): g is SeriesGenresEnum => !!g),
    terms: infoDto.terms.map((term: SeriesTermInfoDto) => ({
      termId: uuid4(),
      sourceLanguage: term.sourceLanguage,
      term: term.term,
      tagType: term.tagType || '',
      otherTag: term.otherTag || '',
      synonyms: [...term.synonyms || []],
      localizationComplexityScore: term.localizationComplexityScore || 0,
      meaning: term.meaning || '',
      translations: Object.entries(term.translations).reduce((acc: Record<string, string>, [lang, translation]) => {
        acc[lang] = translation;
        return acc;
      }, {})
    })),
    internalProjectIds: [...infoDto.internalProjectIds || []],
    externalProjectIds: [...infoDto.externalProjectIds || []],
  };
};